export const websiteBaseURLs: Record<string, string> = {
  'en-ca': 'https://www.vistaprint.ca',
  'en-au': 'https://www.vistaprint.com.au',
  'en-nz': 'https://www.vistaprint.co.nz',
  'en-sg': 'https://www.vistaprint.sg',
  'en-ie': 'https://www.vistaprint.ie',
  'en-gb': 'https://www.vistaprint.co.uk',
  'en-us': 'https://www.vistaprint.com',
};
